var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrequency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z",
    fill: "#55A494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58714 19.5013H10.9761C11.1961 19.5013 11.4 19.3606 11.4571 19.106L11.6936 17.9737L12.8432 23.7053C12.9489 24.2321 13.7482 24.2321 13.8218 23.6969L14.8161 16.6568L15.9821 27.5149C16.0554 28.1647 16.9196 28.1558 16.9686 27.5149L18.045 14.5679L19.1129 27.506C19.17 28.1647 20.0261 28.1647 20.0996 27.506L21.2654 16.6572L22.2682 23.7057C22.3418 24.2409 23.1325 24.2409 23.2468 23.7057L24.38 18.0441L24.6246 19.106C24.6979 19.3956 24.8854 19.5009 25.1057 19.5009H27.4211C27.7475 19.5009 28 19.2291 28 18.8865C28 18.5443 27.7475 18.2636 27.4214 18.2636H25.4643L24.8121 15.5422C24.6657 14.9539 23.9561 14.9539 23.8418 15.5422L22.8311 20.6686L21.6811 12.5843C21.5918 11.9433 20.7682 11.961 20.6946 12.5931L19.6679 22.187L18.5429 8.49369C18.4936 7.83544 17.5968 7.83544 17.5396 8.49369L16.4146 22.187L15.3871 12.5931C15.3221 11.9433 14.4986 11.9433 14.4007 12.5843L13.2511 20.6686L12.2482 15.5422C12.1339 14.9981 11.4086 14.9981 11.2696 15.5422L10.6175 18.2632H8.58714C8.26071 18.2632 8 18.5439 8 18.8865C8 19.2287 8.26071 19.5013 8.58714 19.5013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrequency);
export default __webpack_public_path__ + "static/media/frequency.4b93ae26.svg";
export { ForwardRef as ReactComponent };